/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const SHOW_MODAL = 'conversation/plan/show-modal';
export const CLOSE_MODAL = 'conversation/plan/close-modal';

export const UPGRADE_PLAN_START = 'conversation/plan/upgrade-start';
export const UPGRADE_PLAN_SUCCESS = 'conversation/plan/upgrade-success';
export const UPGRADE_PLAN_ERROR = 'conversation/plan/upgrade-error';

export const GET_ACCOUNT_TYPE = 'conversation/plan/get-account-type';
export const ACCOUNT_TYPE_SUCCESS = 'conversation/plan/account-type-success';
export const ACCOUNT_TYPE_ERROR = 'conversation/plan/account-type-error';

export const LOAD_API_USAGE = 'conversation/plan/load-api-usage';
export const API_USAGE_SUCCESS = 'conversation/plan/api-usage-success';
export const API_USAGE_THRESHOLD = 'conversation/plan/api-usage-threshold';
